// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  left: 0 !important;
  top: 0 !important;
  position: relative !important;
  z-index: 10 !important;
  width: 100% !important;
  height: 50px !important;
  display: unset;
}

.segment-design ion-badge {
  position: relative !important;
  top: -5px !important;
  padding: 1px 4px !important;
  left: 14px !important;
}
.segment-design ion-segment-button {
  font-size: 12px;
  font-weight: 700 !important;
  height: 60px !important;
}

ion-content {
  height: 100% !important;
}

.menu-inner {
  display: block !important;
}

.ion-card-scroll {
  height: calc(100vh - 100px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.custom-size {
  font-size: large;
}`, "",{"version":3,"sources":["webpack://./src/app/right-menu/trip-information/trip-information.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,sBAAA;EAEA,sBAAA;EACA,uBAAA;EACA,cAAA;AAAF;;AAIE;EACE,6BAAA;EACA,oBAAA;EACA,2BAAA;EACA,qBAAA;AADJ;AAIE;EACE,eAAA;EACA,2BAAA;EACA,uBAAA;AAFJ;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,sCAAA;EACA,2BAAA;EACA,6BAAA;AAHF;;AAMA;EACE,gBAAA;AAHF","sourcesContent":["ion-header {\n  left: 0 !important;\n  top: 0 !important;\n  position: relative !important;\n  z-index: 10 !important;\n  // display: block !important;\n  width: 100% !important;\n  height: 50px !important;\n  display: unset;\n}\n\n.segment-design {\n  ion-badge {\n    position: relative !important;\n    top: -5px !important;\n    padding: 1px 4px !important;\n    left: 14px !important;\n  }\n\n  ion-segment-button {\n    font-size: 12px;\n    font-weight: 700 !important;\n    height: 60px !important;\n  }\n}\n\nion-content {\n  height: 100% !important;\n}\n\n.menu-inner {\n  display: block !important;\n}\n\n.ion-card-scroll {\n  height: calc(100vh - 100px) !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n}\n\n.custom-size{\n  font-size: large;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
